const amlTraining = {
  amlCertifiedTraining: 'AML Formazione Certificata',
  correctAnswers: 'Risposte corrette',
  downloadCerticate: 'Download certicato',
  nextLesson: 'Prossima lezione',
  notarizeQuiz: 'Notarizza il quiz',
  notarizeVideoWatch: 'Notarizzare la visione del video',
  passed: 'Superato',
  requestCertificate: 'Richiedi il certificato',
  takeCertificate: 'Prendi il certificato',
  takeCourse: 'Inizia il corso',
  takeQuiz: 'Fai il quiz',
  trainingCompleted:
    'Congratulazioni, hai completato con successo l\'apprendimento ed ottenuto il certificato.',
  watchVideo: 'Guarda il video',
};

export default amlTraining;
